// extracted by mini-css-extract-plugin
export default {"link":"link__x4L2B","row":"row__-PqUW","column":"column__XQIlB","body":"body__aqUWU","core":"core__s3TEY","spin":"spin__EPH6z","spinner":"spinner__iaPbz"};